const domes = [
  {
    img: 'https://legacy-cdn.hiorka.com/imgs/accessories/showcase/closed+domes-medium.jpg',
    title: 'Closed Domes',
    price: '15',
    currency: '',
    unit: 'Per Set (3 Pairs)',
    features: [
      'Medical grade silicone',
      'Adaptive to all situations',
      'Good for feedback reduction'
    ],
    default: 1,
    carousel: [
      {
        size: 'Large',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/large-closed+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/large-closed+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/large-closed+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/large-closed+domes-04.jpg'
        ]
      },
      {
        size: 'Medium',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/medium-closed+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/medium-closed+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/medium-closed+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/medium-closed+domes-04.jpg'
        ]
      },
      {
        size: 'Small',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/small-closed+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/small-closed+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/small-closed+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/small-closed+domes-04.jpg'
        ]
      }
    ],
    poster: 'https://legacy-cdn.hiorka.com/imgs/accessories/domes/domes+cover.jpg',
    video: 'https://legacy-cdn.hiorka.com/howtovideo/replace+domes.mp4',
    tips: [
      'Choose the right size of dome that fits snugly in your ear canal',
      'Choose the dome that is right for you',
      'Recommended to change every 2-3 months'
    ]
  },
  {
    img: 'https://legacy-cdn.hiorka.com/imgs/accessories/showcase/open+domes-medium.jpg',
    title: 'Open Domes',
    price: '15',
    currency: '',
    unit: 'Per Set (3 Pairs)',
    features: [
      'Medical grade silicone',
      'Adaptive to all situations',
      'Good for feedback reduction'
    ],
    default: 1,
    carousel: [
      {
        size: 'Large',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/large-open+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/large-open+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/large-open+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/large-open+domes-04.jpg'
        ]
      },
      {
        size: 'Medium',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/medium-open+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/medium-open+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/medium-open+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/medium-open+domes-04.jpg'
        ]
      },
      {
        size: 'Small',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/small-open+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/small-open+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/small-open+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/small-open+domes-04.jpg'
        ]
      }
    ],
    poster: 'https://legacy-cdn.hiorka.com/imgs/accessories/domes/domes+cover.jpg',
    video: 'https://legacy-cdn.hiorka.com/howtovideo/replace+domes.mp4',
    tips: [
      'Choose the right size of dome that fits snugly in your ear canal',
      'Choose the dome that is right for you',
      'Recommended to change every 2-3 months'
    ]
  },
  {
    img: 'https://legacy-cdn.hiorka.com/imgs/accessories/showcase/double+domes-medium.jpg',
    title: 'Double Domes',
    price: '15',
    currency: '',
    unit: 'Per Set (3 Pairs)',
    features: [
      'Medical grade silicone',
      'Adaptive to all situations',
      'Good for feedback reduction'
    ],
    default: 1,
    carousel: [
      {
        size: 'Large',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/large-double+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/large-double+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/large-double+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/large-double+domes-04.jpg'
        ]
      },
      {
        size: 'Medium',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/medium-double+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/medium-double+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/medium-double+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/medium-double+domes-04.jpg'
        ]
      },
      {
        size: 'Small',
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/small-double+domes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/small-double+domes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/small-double+domes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/small-double+domes-04.jpg'
        ]
      }
    ],
    poster: 'https://legacy-cdn.hiorka.com/imgs/accessories/domes/domes+cover.jpg',
    video: 'https://legacy-cdn.hiorka.com/howtovideo/replace+domes.mp4',
    tips: [
      'Choose the right size of dome that fits snugly in your ear canal',
      'Choose the dome that is right for you',
      'Recommended to change every 2-3 months'
    ]
  }
]

const maintenance = [
  {
    img: 'https://legacy-cdn.hiorka.com/imgs/accessories/showcase/brushes.jpg',
    title: 'Wax Guard',
    price: '10',
    currency: '',
    unit: 'Per Pack',
    features: [
      'Keep receiver clean to ensure good sound quality',
      'Eight filters in one pack',
      'A cleaning brush as a perk'
    ],
    carousel: [
      {
        imgs: [
          'https://legacy-cdn.hiorka.com/imgs/accessories/maintenance+tools/wax+guard/brushes-01.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/maintenance+tools/wax+guard/brushes-02.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/maintenance+tools/wax+guard/brushes-03.jpg',
          'https://legacy-cdn.hiorka.com/imgs/accessories/maintenance+tools/wax+guard/brushes-04.jpg'
        ]
      }
    ],
    video: 'https://legacy-cdn.hiorka.com/howtovideo/wax+guards.mp4',
    poster: 'https://legacy-cdn.hiorka.com/imgs/accessories/maintenance+tools/wax+guard/brushes+cover.jpg',
    tips: [
      'Check the wax guard if it\'s blocked by earwax whenever the sounds become softer',
      'A wax guard has an installation and romover',
      'One pack can last for 2-3 months'
    ]
  }
]

const data = {
  domes: {
    title: 'Domes',
    description: 'Comfort and a snug fit',
    data: domes
  },
  maintenance: {
    title: 'Maintenance Tools',
    description: 'Free from earwax, better sound quality',
    data: maintenance
  }
}

const dataMap = {
  'Closed Domes': domes[0],
  'Open Domes': domes[1],
  'Double Domes': domes[2],
  'Wax Guard': maintenance[0]
}

export { data, dataMap }
